import { useMembershipModalState } from '../../../../../../../modalContext';

type Result = {
	errorMessage: string | null;
};

export function useValidationErrorMessage(): Result {
	const [{ validationErrors }] = useMembershipModalState();
	return {
		errorMessage: validationErrors?.amount ?? null,
	};
}
